export enum BonusRolloverAmountType {
  GRANTED_BONUS = 1,
  QUALIFYING = 2,
  GRANTED_BONUS_QUALIFYING = 3,
}
